module.exports = __webpack_public_path__ + "img/Close_L2.c139bd44.svg";